export const filterWarehouse = (warehouses, userAccount) =>
  // warehouses
  warehouses.filter(warehouse => warehouse.id !== 1)
  // for whitelisting
  // userAccount ?
  // warehouses.filter(warehouse =>
  //   !accountNumber.find(accountNumber => accountNumber === userAccount.account_number)
  //     ? warehouse.id !== 1
  //     : warehouse.id !== 6,
  // ) : warehouses.filter(warehouse => warehouse.id !== 1)

  export const accountNumber = [
    // staging account number
    // '53-504119',
    // '86-352797',
    // '28-834174',
    // '59-898183',
    // '24-171330',
    // '53-228572',
    // '37-819426',
    // '12-497200',
    // '12-420535',
    // '43-687767',
    // '88-167625',
    // '73-742646',
    // '48-199091',
    // '80-100137',
    // '23-219601',
    // '64-312855',
    //prod
    '63-295648',
    '20-595738',
    '12-420535',
    '61-854920',
    '82-732382',
    '28-615882',
    '77-363736',
    '59-653617',
    '71-534632',
    '88-886422',
    '28-734851',
    '99-4657',
    '68-249652',
    '99-3423',
    '38-610054',
    '77-141334',
    '38-444426',
    '63-962263',
    '55-844621',
    '54-534745',
    '66-480119',
  ];



/** WEBPACK FOOTER **
 ** ./src/utils/whiteListed.js
 **/